import React from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, KTIcon, toAbsoluteUrl, WithChildren } from '../../../helpers'
import { useLayout } from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const AsideMenuItem: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { aside } = config

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link', { active: isActive })} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            {isActive && (
              <span className='bullet bullet-dot'></span>
            )}
          </span>
        )}
        {icon && fontIcon === 'ofindo' && (
          <span className='menu-icon'>
            <img
              className='h-25px theme-light-show'
              src={toAbsoluteUrl(`/media/icons/ofindo/${icon}.svg`)} alt="Menü"
            />
            <img
              className='h-25px theme-dark-show'
              src={toAbsoluteUrl(`/media/icons/ofindo/${icon}-dark.svg`)} alt="Menü"
            />
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && fontIcon !== 'ofindo' && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-5' />
          </span>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export { AsideMenuItem }
